import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLecture as createLectureApi } from "../../../../services/dashboard/apiLectures";
import toast from "react-hot-toast";

function useCreateLecture() {
    const queryClient = useQueryClient();

    const {
        mutate: createLecture,
        isPending: isCreating,
        error,
    } = useMutation({
        mutationFn: createLectureApi,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["lecturesDashboard"],
            });

            toast.success("تم أنشاء المحاضره بنجاح");
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { createLecture, isCreating, error };
}

export default useCreateLecture;
